import React, { useContext, useEffect, useRef } from 'react';
import { CAFContext } from '../../contexts/caf';
import { CAFContainer } from '../../components/CafContainer';
import { useCAFModal } from '../../hooks/services/caf';
import { CAFContextValue } from '../../types/caf';

import GlobalContext from '../../contexts/GlobalContext';
import { CAF_INIIAL_STATE } from '../../config/caf';

export const CAFModal = (): JSX.Element => {
  const { cafContext } = useContext<CAFContextValue>(CAFContext);
  const { globalContext } = useContext(GlobalContext);
  const handlers = useCAFModal({ initialState: CAF_INIIAL_STATE});
  const bodyRef = useRef(document.body);

  useEffect(() => {
    globalContext.gtm.setVirtualPage('Caf_Landing_Page');
  }, []);

  useEffect(() => {
    if (handlers?.cafState?.isModalOpen && !bodyRef.current.classList.contains('stop-scroll')) {
      bodyRef.current.classList.add('stop-scroll');
    } else if (bodyRef.current.classList.contains('stop-scroll')) {
      bodyRef.current.classList.remove('stop-scroll');
    }
  }, [handlers?.cafState?.isModalOpen]);

  if (handlers?.cafState?.isModalOpen) {
    return <CAFContainer handlers = {handlers}/>;
  }

  return <></>;
};
